import { useNavigate } from 'react-router-dom';
import { CommandDialog, CommandInput, CommandList, CommandItem, CommandEmpty, CommandGroup } from '../ui/command';

const GROUP_DEFS = [
  ['students', 'Students', (s) => `${s.name} - Grade ${s.grade}${s.section}`, (s) => `/students/${s.id}`],
  ['applications', 'Applications', (a) => `${a.applicant_name} - ${a.stage}`, () => '/admissions'],
  ['users', 'Staff', (u) => `${u.name} - ${u.role?.replace(/_/g, ' ')}`, () => '/directory'],
  ['invoices', 'Invoices', (i) => `${i.student_name} - ${i.plan_name} (${i.status})`, () => '/fees'],
  ['books', 'Library', (b) => `${b.title} - ${b.author}`, () => '/library'],
  ['exams', 'Exams', (x) => `${x.name} - ${x.status}`, () => '/exams'],
  ['routes', 'Transport routes', (r) => r.name, () => '/transport'],
];

export const SearchPalette = ({ open, setOpen, q, setQ, search, items }) => {
  const nav = useNavigate();
  const go = (path) => { setOpen(false); nav(path); };
  return (
    <CommandDialog open={open} onOpenChange={setOpen} shouldFilter={false}>
      <CommandInput placeholder="Search across your tenant..." value={q} onValueChange={setQ} data-testid="command-search-input" />
      <CommandList>
        <CommandEmpty>Nothing found.</CommandEmpty>
        {GROUP_DEFS.map(([key, heading, fmt, path]) => (search?.[key]?.length > 0 && (
          <CommandGroup key={key} heading={heading}>
            {search[key].map((row) => (
              <CommandItem key={row.id} onSelect={() => go(path(row))}>{fmt(row)}</CommandItem>
            ))}
          </CommandGroup>
        )))}
        <CommandGroup heading="Navigate">
          {items.map((it) => <CommandItem key={it.to} onSelect={() => go(it.to)}>{it.label}</CommandItem>)}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
};
